import React from 'react';
import './quantity-editor.scss';
import { isUndefined } from 'lodash';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';
import { TouchableOpacity } from '../../common';
import { ReactComponent as AddIcon } from '@zonofi/svg-icons/add-plus-icon.svg';
import { ReactComponent as MinusIcon } from '@zonofi/svg-icons/minus-icon.svg';
import { OrderProduct } from '@zonofi/zono-money-store';
import { UomSelector } from './uom-selector';

interface QuantityEditorCardProps {
  quantity: number;
  price?: number;
  onQuantityChange?: (value: number) => void;
  onInputBlur?: () => void;
  onMinusPress?: () => void;
  onPlusPress?: () => void;
  disable?: boolean;
  disableStepper?: boolean;
  isUnmapped?: boolean;
  openUomModal?: () => void;
  product: OrderProduct;
}

export const QuantityEditorCard: React.FC<QuantityEditorCardProps> = ({
  quantity,
  price,
  onQuantityChange,
  onInputBlur,
  onMinusPress,
  onPlusPress,
  disable,
  disableStepper = false,
  openUomModal,
  isUnmapped = false,
  product,
}) => {
  return (
    <div className="quantity-editor-card">
      {!isUndefined(price) && (
        <span className="quantity-editor-container-text font-medium">
          {getFormattedAmount(price)}
        </span>
      )}
      <div className="quantity-editor-container">
        <div
          className={`quantity-editor-controls ${isUnmapped || disableStepper ? 'unmapped' : ''}`}
        >
          <div
            className={`quantity-editor-amount-edit ${isUnmapped || disableStepper ? 'unmapped' : ''}`}
          >
            <TouchableOpacity
              className=""
              onPress={onMinusPress}
              disabled={disable || isUnmapped || disableStepper}
            >
              <MinusIcon
                style={{
                  color: isUnmapped || disableStepper ? '#8C8C8C' : '#FFFFFF',
                }}
              />
            </TouchableOpacity>

            <input
              type="text"
              className={`quantity-editor-input font-semibold ${isUnmapped ? 'unmapped' : ''}`}
              value={isUnmapped ? '0' : quantity?.toString()}
              onChange={(e) => onQuantityChange?.(Number(e.target.value))}
              onBlur={onInputBlur}
              inputMode="numeric"
              disabled={isUnmapped || disableStepper}
            />

            <TouchableOpacity
              className=""
              onPress={onPlusPress}
              disabled={isUnmapped || disableStepper}
            >
              <AddIcon
                style={{
                  color: isUnmapped || disableStepper ? '#8C8C8C' : '#FFFFFF',
                }}
              />
            </TouchableOpacity>
          </div>
          {!isUnmapped && (
            <UomSelector
              openUomModal={openUomModal}
              quantity={quantity}
              product={product}
              disabled={disableStepper}
            />
          )}
        </div>
      </div>
    </div>
  );
};
